import { NewsletterWidgetElement } from './define-newsletter-element';

export function registerNewsletterWidget(tagName = 'adipa-newsletter-widget'): void {
  if (typeof customElements === 'undefined') return;
  if (customElements.get(tagName)) return;
  customElements.define(tagName, NewsletterWidgetElement);
}
